import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7dafe135")

_pushScopeId("data-v-7dafe135")
const _hoisted_1 = { class: "button-frame" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("施設登録")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("施設にログイン")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("アカウント設定")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("ログアウト")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("ログアウトしますか？ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("div", null, _toDisplayString(_ctx.today), 1)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_normal_button, {
          class: "dashboard-button",
          state: "normal",
          large: true,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/register_clinic')))
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_normal_button, {
          class: "dashboard-button",
          state: "normal",
          large: true,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/signin_clinic')))
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_normal_button, {
          class: "dashboard-button",
          state: "warning",
          large: true,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/account')))
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_normal_button, {
          class: "dashboard-button",
          state: "normal-gray",
          large: true,
          onClick: _ctx.onLogout
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_confirm, {
        ref: "confirmRef",
        onYes: _ctx.yes
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})